import { render } from "./Guide.vue?vue&type=template&id=0ca8424c&ts=true"
import script from "./Guide.vue?vue&type=script&lang=ts"
export * from "./Guide.vue?vue&type=script&lang=ts"

import "./Guide.vue?vue&type=style&index=0&id=0ca8424c&lang=scss"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__